import { type Control, Controller } from 'react-hook-form';
import { z } from 'zod';

import { InputFile, type InputFileProps } from '@/components/controls';

export type FormInputFileProps = InputFileProps & {
  control?: Control;
  name: string;
};

export const FormInputFile = ({
  control,
  name,
  ...props
}: FormInputFileProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <InputFile
            {...props}
            value={value}
            onChange={(files) => {
              onChange(files);
            }}
          />
        );
      }}
    />
  );
};

FormInputFile.displayName = 'Form.InputFile';

export const required = (message = 'Please upload a file', min = 1) => {
  return z.any().refine(
    (files) => {
      if (Array.isArray(files)) {
        return files.length >= min;
      }
      return files !== null && files !== undefined;
    },
    { message },
  );
};

FormInputFile.rules = {
  required,
};
